(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */

    let initializeBlock = function( $block ) {
        
        let slider   = $block.find('.slider-multiquotes');
        let slide    = $block.find('.slide-multiquote');
        let controls = $block.find('.slider-controls');

        let sliderSettings = {
            dots          : true,
            arrows        : false,
            appendDots    : $(controls),
            speed         : 500,
            cssEase       : 'ease-in-out',
            infinite      : false,
            slidesToShow  : 3,
            slidesToScroll: 3,

            responsive: [
            {
                breakpoint: 1025,
                settings  : {
                    slidesToShow  : 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 641,
                settings  : {
                    slidesToShow  : 1,
                    slidesToScroll: 1,
                    speed         : 250,
                    cssEase       : 'ease-out',
                    touchThreshold: 12,
                }
            },
            ],
        };

        if ($(slide).length  > 1) {
            $(slider).slick(sliderSettings);
        }
    }



    //        Init blocks in front and admin editor
    // ==============================================

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.block-multiquotes').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=multiquotes', initializeBlock );
    }

})(jQuery);